import { addDays, toISODate } from './date';
import { AnnualWeekdayKey } from '../types/domain';

export function mondayIsoForDateInLocal(d: Date): string {
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  const mon = new Date(d);
  mon.setDate(d.getDate() + diff);
  return toISODate(mon);
}

/**
 * program_progress / AnnualWeekdayKey. 일요(0)은 null.
 */
export function dateToWeekdayKey(d: Date): AnnualWeekdayKey | null {
  const j = d.getDay();
  if (j === 0) return null;
  return (['mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const)[j - 1];
}

/**
 * 대시보드 < >: 연간 시간표에 일요 열이 없으므로 일요일을 건너뜀(토 → 월, 월 ← 토).
 */
export function addDaysForDashboardNav(prev: Date, direction: 1 | -1): Date {
  let d = addDays(prev, direction);
  while (d.getDay() === 0) {
    d = addDays(d, direction);
  }
  return d;
}

/** base_timetable_cells.weekday: 1=월 … 6=토, 일제외 */
export function dateToBaseTimetableWeekday(d: Date): number | null {
  const j = d.getDay();
  if (j === 0) return null;
  return j;
}
